module.exports = require("prop-types");


//////////////////
// WEBPACK FOOTER
// external "prop-types"
// module id = 1
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///external "prop-types"